module.exports = __webpack_public_path__ + "img/nav_video.60223fe8.png";